const actions = {
  CREATE_BRANCH_BEGIN: "CREATE_BRANCH_BEGIN",
  CREATE_BRANCH_SUCCESS: "CREATE_BRANCH_SUCCESS",
  CREATE_BRANCH_ERR: "CREATE_BRANCH_ERR",

  LIST_BRANCHES_BEGIN: "LIST_BRANCHES_BEGIN",
  LIST_BRANCHES_SUCCESS: "LIST_BRANCHES_SUCCESS",
  LIST_BRANCHES_ERR: "LIST_BRANCHES_ERR",

  UPDATE_BRANCH_BEGIN: "UPDATE_BRANCH_BEGIN",
  UPDATE_BRANCH_SUCCESS: "UPDATE_BRANCH_SUCCESS",
  UPDATE_BRANCH_ERR: "UPDATE_BRANCH_ERR",

  DELETE_BRANCH_BEGIN: "DELETE_BRANCH_BEGIN",
  DELETE_BRANCH_SUCCESS: "DELETE_BRANCH_SUCCESS",
  DELETE_BRANCH_ERR: "DELETE_BRANCH_ERR",

  BLOCK_BRANCH_BEGIN: "BLOCK_BRANCH_BEGIN",
  BLOCK_BRANCH_SUCCESS: "BLOCK_BRANCH_SUCCESS",
  BLOCK_BRANCH_ERR: "BLOCK_BRANCH_ERR",

  UNBLOCK_BRANCH_BEGIN: "UNBLOCK_BRANCH_BEGIN",
  UNBLOCK_BRANCH_SUCCESS: "UNBLOCK_BRANCH_SUCCESS",
  UNBLOCK_BRANCH_ERR: "UNBLOCK_BRANCH_ERR",

  GET_BRANCH_DETAILS_BEGIN: "GET_BRANCH_DETAILS_BEGIN",
  GET_BRANCH_DETAILS_SUCCESS: "GET_BRANCH_DETAILS_SUCCESS",
  GET_BRANCH_DETAILS_ERR: "GET_BRANCH_DETAILS_ERR",

  createBranchBegin: () => {
    return {
      type: actions.CREATE_BRANCH_BEGIN,
    };
  },

  createBranchSuccess: (data) => {
    return {
      type: actions.CREATE_BRANCH_SUCCESS,
      data,
    };
  },

  createBranchErr: (err) => {
    return {
      type: actions.CREATE_BRANCH_ERR,
      err,
    };
  },

  listBranchesBegin: () => {
    return {
      type: actions.LIST_BRANCHES_BEGIN,
    };
  },

  listBranchesSuccess: (data) => {
    return {
      type: actions.LIST_BRANCHES_SUCCESS,
      data,
    };
  },

  listBranchesErr: (err) => {
    return {
      type: actions.LIST_BRANCHES_ERR,
      err,
    };
  },

  updateBranchBegin: () => {
    return {
      type: actions.UPDATE_BRANCH_BEGIN,
    };
  },

  updateBranchSuccess: (data) => {
    return {
      type: actions.UPDATE_BRANCH_SUCCESS,
      data,
    };
  },

  updateBranchErr: (err) => {
    return {
      type: actions.UPDATE_BRANCH_ERR,
      err,
    };
  },

  deleteBranchBegin: () => {
    return {
      type: actions.DELETE_BRANCH_BEGIN,
    };
  },

  deleteBranchSuccess: (data) => {
    return {
      type: actions.DELETE_BRANCH_SUCCESS,
      data,
    };
  },

  deleteBranchErr: (err) => {
    return {
      type: actions.DELETE_BRANCH_ERR,
      err,
    };
  },

  blockBranchBegin: () => {
    return {
      type: actions.BLOCK_BRANCH_BEGIN,
    };
  },

  blockBranchSuccess: (data) => {
    return {
      type: actions.BLOCK_BRANCH_SUCCESS,
      data,
    };
  },

  blockBranchErr: (err) => {
    return {
      type: actions.BLOCK_BRANCH_ERR,
      err,
    };
  },

  unblockBranchBegin: () => {
    return {
      type: actions.UNBLOCK_BRANCH_BEGIN,
    };
  },

  unblockBranchSuccess: (data) => {
    return {
      type: actions.UNBLOCK_BRANCH_SUCCESS,
      data,
    };
  },

  unblockBranchErr: (err) => {
    return {
      type: actions.UNBLOCK_BRANCH_ERR,
      err,
    };
  },

  getBranchDetailsBegin: () => {
    return {
      type: actions.GET_BRANCH_DETAILS_BEGIN,
    };
  },

  getBranchDetailsSuccess: (data) => {
    return {
      type: actions.GET_BRANCH_DETAILS_SUCCESS,
      data,
    };
  },

  getBranchDetailsErr: (err) => {
    return {
      type: actions.GET_BRANCH_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
